// extracted by mini-css-extract-plugin
module.exports = {"box":"heroComponent_box__qTUpB","boxHelper":"heroComponent_boxHelper__kCgY3","boxTitle":"heroComponent_boxTitle__xq9Lc","linkButton":"heroComponent_linkButton__8fAj7"};